(function () {
    var directivesModule = angular.module('customeDirectivesModule');

    directivesModule.directive('npReadingReceiptButton', ['$document', function ($document) {
        return {
            restrict: 'E',
            controller: ['$scope', 'readingConfirmationService', '$http', controller],
            scope: {
                entityId: '=',
                folderId: '=',
                entityDisabled: '='
            },
            templateUrl: paths.ReadingReceiptButtonView,
            replace: true,
            link: function (scope, element, attr) {
                $document.bind('click', function (event) {
                    var isClickedElementChildOfPopup = element
                      .find(event.target)
                      .length > 0;

                    if (isClickedElementChildOfPopup)
                        return;
                    scope.readingReciept.showReadingRecieptContextMenu = false;
                    scope.$apply();
                });
            }
        };
    }]);

    function controller($scope, readingConfirmationService, $http) {
        $scope.translation = globalResources;
        if ($scope.translation.ReadingReciept.indexOf('\n(CTRL + ALT + L)') <= 0) {
            $scope.translation.ReadingReciept = $scope.translation.ReadingReciept + '\n(CTRL + ALT + L)';
        }

        $scope.isShowReConfirm = false;
        $scope.readingReciept = { showReadingRecieptContextMenu : false };

        $scope.currentData = {
            readConfirmationDate: '',
            confirmedReadLast: '',
            fullName: ''
        };

        $scope.getConfirmInformation = function () {
            if (!$scope.currentData.readConfirmationDate && !$scope.currentData.fullName) {
                readingConfirmationService.GetConfirmInformation($scope.entityId)
               .then(function (response) {
                   $scope.currentData = response.data;
                   if (response.data.readConfirmationDate) {
                       $scope.currentData.confirmedReadLast = String.format($scope.translation.ConfirmedReadLast, response.data.readConfirmationDate);
                       var readConfirmationDate = new Date(response.data.readConfirmationDateTime);
                       $scope.isShowReConfirm = (compareDate(readConfirmationDate, new Date()) == false);
                   }
               });
            }
        };

        function compareDate(date1, date2) {
            if (date1.getFullYear() != date2.getFullYear()) {
                return false;
            }
            if (date1.getMonth() != date2.getMonth()) {
                return false;
            }
            if (date1.getDate() != date2.getDate()) {
                return false;
            }
            return true;
        }

        $scope.sendReadingConfirmation = function () {
            readingConfirmationService.sendReadingConfirmation($scope.entityId, $scope.folderId)
                .then(function (data) {
                    if (data) {
                        $scope.currentData.readConfirmationDate = data.replace('"', '').replace('"', '');
                        $scope.currentData.confirmedReadLast = String.format($scope.translation.ConfirmedReadLast, $scope.currentData.readConfirmationDate);
                        $scope.isShowReConfirm = false;
                    }
                });
        };

        $scope.$on(broadcastType.toggleReadingReceiptTarget, function (e, target) {
            $scope.getConfirmInformation();
            $scope.readingReciept.showReadingRecieptContextMenu = true;
        });
    }

})();